import picVideo from './pic&video'
export default {
  components: { picVideo },
  data() {
    return {
      rowData: {},
      viewType: '',
      picVideoVisible: false
    }
  },
  methods: {
    showDialog(rowData, type) {
      this.rowData = rowData;
      this.viewType = type;
      this.picVideoVisible = true;
    },
    // 显示查看图片、视频按钮
    showDetailBtn(rowData, type) {
      if (rowData.picList && rowData.picList.length) {
        return true;
      }else{
        return false;
      }
    }
  }
}